import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/srv/build-dir/COR-FRON-BUIL/node_modules/css-loader/dist/runtime/api.js'
import '/srv/build-dir/COR-FRON-BUIL/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/srv/build-dir/COR-FRON-BUIL/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import wildRinganaCorporateVueApp from '~root/./src/App.vue?shadow'
window.customElements.define('wild-ringana-corporate-vue-app', wrap(Vue, wildRinganaCorporateVueApp))